<form [formGroup]="receivedFormGroup">
  <div class="vh">
    <ng-container>
      <ng-container formArrayName="owners">
        <div class="row">
          @for (owner of owners?.controls; track owner; let index = $index) {
            <ng-container [formGroup]="owner">
              <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
                <owner-header [owners]="owners" [index]="index"></owner-header>
                <ng-container
                  [ngTemplateOutlet]="template || default"
                  [ngTemplateOutletContext]="{
                    $implicit: owner,
                    form: receivedFormGroup,
                    index: index,
                  }"
                >
                </ng-container>
              </div>
            </ng-container>
          }
        </div>
      </ng-container>
    </ng-container>
  </div>
</form>
<ng-template #default></ng-template>
